import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import './App.css';

import TenantProvider from './core/TenantProvider';
import Router from './router';

function App() {
  return (
    <BrowserRouter>
      <TenantProvider>
        <Router />
      </TenantProvider>
    </BrowserRouter>
  );
}

export default App;
